import { useSelectorEx } from "./redux";

function useAuthCheck() {
    const user = useSelectorEx(state => state.auth.user);
    const token = localStorage.getItem('token');
    return !user || !token;
}
export default useAuthCheck;